import React from "react";
import {PATH} from "../../../config";
import {Col} from "antd";

const BenefitsItem = () => {

    const data = [
        {
            benefitId: 0,
            benefitBg: 'ticket1.png',
            benefitName: 'Event Hosting',
            benefitInfo: 'Create an event and sell your tickets as NFTs',
        },
        {
            benefitId: 1,
            benefitBg: 'sell-nft.png',
            benefitName: 'NFT Trading',
            benefitInfo: 'Showcase & trade your NFTs in your Metahut',
        },
        {
            benefitId: 2,
            benefitBg: 'gov1.png',
            benefitName: 'Governance',
            benefitInfo: 'Participate in the governance',
        },
        {
            benefitId: 3,
            benefitBg: 'prop3.png',
            benefitName: 'Renting Properties',
            benefitInfo: 'Earn $METO by renting your properties',
        },
        {
            benefitId: 4,
            benefitBg: 'colab.png',
            benefitName: 'Brand Collaboration',
            benefitInfo: 'Performance-based model of collaboration',
        },
        {
            benefitId: 5,
            benefitBg: 'iconn2.png',
            benefitName: 'Web 3.0 Adoption',
            benefitInfo: 'Be a pioneer of the Metaverse',
        },
        {
            benefitId: 6,
            benefitBg: 'sell1.png',
            benefitName: 'MetaCommerce',
            benefitInfo: 'Sell your virtual and physical products',
        },
        {
            benefitId: 7,
            benefitBg: 'iconn1.png',
            benefitName: 'Clan Activities',
            benefitInfo: 'Socialize and host events with clan members',
        },
    ]

    return (
        data.map((item) => {
            return (
                <Col xs={24} sm={12} md={8} lg={6} className="gutter-row py-8" key={item.benefitId}>
                    <div className="bg-indigo-900 px-8 py-8 rounded-xl text-center">
                        <img src={PATH + item.benefitBg} alt="" style={{width: "70px", height: "70px"}} className="mb-6" />
                        <h4 className="text-xl text-white">{item.benefitName}</h4>
                        <p className="opacity-50" style={{lineHeight: "24px", fontSize: "16px"}}>{item.benefitInfo}</p>
                    </div>
                </Col>
            )
        })
    )
}

export default BenefitsItem;